<div class="embed-consent" [class.embed-consent--compact]="compact()" role="group" [attr.aria-label]="titleKey | transloco">
  <span class="embed-consent__icon" aria-hidden="true">
    <ptl-icon [icon]="LucideCookie" size="m"></ptl-icon>
  </span>

  <div class="embed-consent__body">
    <span class="embed-consent__title">{{ titleKey | transloco }}</span>
    <span class="embed-consent__text">{{ textKey | transloco: { site: siteLabel() ?? (unknownSiteKey | transloco) } }}</span>

    <div class="embed-consent__actions">
      <ptl-button [type]="'primary'" [size]="'sm'" [text]="settingsKey | transloco" (clicked)="openSettings()"></ptl-button>
      @if (url()) {
        <a class="embed-consent__link" [href]="url()" target="_blank" rel="noopener noreferrer">
          <span>{{ openKey | transloco }}</span>
          <ptl-icon [icon]="LucideExternalLink" size="xs"></ptl-icon>
        </a>
      }
    </div>
  </div>
</div>
